export default __webpack_public_path__ + "static/media/river_bank_filtration.4772bb35.png";